var _rect, _path, _rect2, _path2, _rect3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestExamQuizIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 44,
    height: 48,
    rx: 5,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H46",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 6,
    height: 6,
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29H44",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38,
    width: 6,
    height: 6,
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41H44",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46L54 38L58 42L50 50L44 52L46 46Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestExamQuizIcon);
export default __webpack_public_path__ + "static/media/test_exam_quiz_icon.d11384bce46d28975caef0ff03927d06.svg";
export { ForwardRef as ReactComponent };